module.exports = __webpack_public_path__ + "img/7.96ac120b.jpg";